export default __webpack_public_path__ + "static/media/foot-twit.6c00bfd2.png";